// Assets
// Custom icons
import {
  AdobexdLogo,
  AtlassianLogo,
  InvisionLogo,
  JiraLogo,
  SlackLogo,
  SpotifyLogo,
} from "components/Icons/Icons.js";
import { AiOutlineExclamation } from "react-icons/ai";
import {
  FaArrowDown,
  FaArrowUp,
  FaBell,
  FaCreditCard,
  FaFilePdf,
  FaHtml5,
  FaShoppingCart,
} from "react-icons/fa";
import { SiDropbox } from "react-icons/si";

export const onSiteVehiclesOptionsJRG1 = [
  {
    label: "401[SA]21",
    value: "401[SA]21",
  },
  {
    label: "401[SA]22",
    value: "401[SA]22",
  },
  {
    label: "401[SA]25",
    value: "401[SA]25",
  },
  {
    label: "401[SA]27",
    value: "401[SA]27",
  },
  {
    label: "401[SA]52",
    value: "401[SA]52",
  },
  {
    label: "401[SA]44",
    value: "401[SA]44",
  },
  {
    label: "401[SA]43",
    value: "401[SA]43",
  },
  {
    label: "401[SA]49",
    value: "401[SA]49",
  },
  {
    label: "401[SA]71",
    value: "401[SA]71",
  },
  {
    label: "401[SA]81",
    value: "401[SA]81",
  },
  {
    label: "401[SA]64",
    value: "401[SA]64",
  },
  {
    label: "401[SA]61",
    value: "401[SA]61",
  },
  {
    label: "401[SA]60",
    value: "401[SA]60",
  },
  {
    label: "401[SA]93",
    value: "401[SA]93",
  },
  {
    label: "400[SA]90",
    value: "400[SA]90",
  },
  {
    label: "120[SA]94",
    value: "120[SA]94",
  },
  {
    label: "401[SA]39",
    value: "401[SA]39",
  },
  {
    label: "R5",
    value: "R5",
  },
  {
    label: "R13",
    value: "R13",
  },
  {
    label: "Dromader",
    value: "Dromader",
  },
];

export const onSiteVehiclesOptionsSP = [
  {
    label: "251[SA]21",
    value: "251[SA]21",
  },
  {
    label: "251[SA]22",
    value: "251[SA]22",
  },
  {
    label: "251[SA]25",
    value: "251[SA]25",
  },
  {
    label: "251[SA]43",
    value: "251[SA]43",
  },
  {
    label: "251[SA]51",
    value: "251[SA]51",
  },
  {
    label: "251[SA]93",
    value: "251[SA]93",
  },
  {
    label: "251[SA]55",
    value: "251[SA]55",
  },
  {
    label: "251[SA]56",
    value: "251[SA]56",
  },
];

export const onSiteVehiclesOptionsJRG2 = [
  {
    label: "402[SA]21",
    value: "402[SA]21",
  },
  {
    label: "402[SA]22",
    value: "402[SA]22",
  },
  {
    label: "402[SA]25",
    value: "402[SA]25",
  },
  {
    label: "402[SA]43",
    value: "402[SA]43",
  },
  {
    label: "402[SA]51",
    value: "402[SA]51",
  },
  {
    label: "402[SA]90",
    value: "402[SA]90",
  },
  {
    label: "402[SA]71",
    value: "402[SA]71",
  },
  {
    label: "402[SA]72",
    value: "402[SA]72",
  },
  {
    label: "402[SA]73",
    value: "402[SA]73",
  },
  {
    label: "402[SA]59",
    value: "402[SA]59",
  },
  {
    label: "402[SA]91",
    value: "402[SA]91",
  },
];

export const onSiteVehiclesOptionsWSP = [
  {
    label: "881[SA]25",
    value: "881[SA]25",
  },
  {
    label: "881[SA]39",
    value: "881[SA]39",
  },
  {
    label: "881[SA]91",
    value: "881[SA]91",
  },
];

export const sluzby = [
  {
    label: "SARA",
    value: "SARA",
    color: "orange",
  },
  {
    label: "SAMD",
    value: "SAMD",
    color: "cyan",
  },
  {
    label: "SAPD",
    value: "SAPD",
    color: "blue",
  },
]

export const grupy = [
  {
    label: "Brak osób",
    value: "Brak osób",
    color: "green",
  },
  {
    label: "SGPR",
    value: "SGPR",
    color: "cyan",
  },
  {
    label: "SGRT",
    value: "SGRT",
    color: "orange",
  },
  {
    label: "SGRChem",
    value: "SGRChem",
    color: "yellow",
  },
  {
    label: "SGRMed",
    value: "SGRMed",
    color: "pink",
  },
  {
    label: "OSP",
    value: "OSP",
    color: "red",
  },
]


export const timelineData = [
  {
    logo: FaBell,
    title: "$2400, Design changes",
    date: "22 DEC 7:20 PM",
    color: "teal.300",
  },
  {
    logo: FaHtml5,
    title: "New order #4219423",
    date: "21 DEC 11:21 PM",
    color: "orange",
  },
  {
    logo: FaShoppingCart,
    title: "Server Payments for April",
    date: "21 DEC 9:28 PM",
    color: "blue.400",
  },
  {
    logo: FaCreditCard,
    title: "New card added for order #3210145",
    date: "20 DEC 3:52 PM",
    color: "orange.300",
  },
  {
    logo: SiDropbox,
    title: "Unlock packages for Development",
    date: "19 DEC 11:35 PM",
    color: "purple",
  },
  {
    logo: AdobexdLogo,
    title: "New order #9851258",
    date: "18 DEC 4:41 PM",
  },
];


export const rtlTimelineData = [
  {
    logo: FaBell,
    title: "$2400, تغييرات في التصميم",
    date: "22 DEC 7:20 PM",
    color: "teal.300",
  },
  {
    logo: FaHtml5,
    title: "طلب جديد #4219423",
    date: "21 DEC 11:21 PM",
    color: "orange",
  },
  {
    logo: FaShoppingCart,
    title: "مدفوعات الخادم لشهر أبريل",
    date: "21 DEC 9:28 PM",
    color: "blue.400",
  },
  {
    logo: FaCreditCard,
    title: "تمت إضافة بطاقة جديدة للطلب #3210145",
    date: "20 DEC 3:52 PM",
    color: "orange.300",
  },
  {
    logo: SiDropbox,
    title: "فتح الحزم من أجل التنمية",
    date: "19 DEC 11:35 PM",
    color: "purple",
  },
  {
    logo: AdobexdLogo,
    title: "طلب جديد #9851258",
    date: "18 DEC 4:41 PM",
  },
];


export const tablesProjectData = [
  {
    logo: AdobexdLogo,
    name: "Chakra UI Version",
    budget: "$14,000",
    status: "Working",
    progression: 60,
  },
  {
    logo: AtlassianLogo,
    name: "Add Progress Track",
    budget: "$3,000",
    status: "Canceled",
    progression: 10,
  },
  {
    logo: SlackLogo,
    name: "Fix Platform Errors",
    budget: "Not set",
    status: "Done",
    progression: 100,
  },
  {
    logo: SpotifyLogo,
    name: "Launch our Mobile App",
    budget: "$32,000",
    status: "Done",
    progression: 100,
  },
  {
    logo: JiraLogo,
    name: "Add the New Pricing Page",
    budget: "$400",
    status: "Working",
    progression: 25,
  },
];

export const invoicesData = [
  {
    date: "March, 01, 2020",
    code: "#MS-415646",
    price: "$180",
    logo: FaFilePdf,
    format: "PDF",
  },
  {
    date: "February, 10, 2020",
    code: "#RV-126749",
    price: "$250",
    logo: FaFilePdf,
    format: "PDF",
  },
  {
    date: "April, 05, 2020",
    code: "#FB-212562",
    price: "$560",
    logo: FaFilePdf,
    format: "PDF",
  },
  {
    date: "June, 25, 2019",
    code: "#QW-103578",
    price: "$120",
    logo: FaFilePdf,
    format: "PDF",
  },
  {
    date: "March, 01, 2019",
    code: "#AR-803481",
    price: "$300",
    logo: FaFilePdf,
    format: "PDF",
  },
];

export const billingData = [
  {
    name: "Oliver Liam",
    company: "Viking Burrito",
    email: "oliver@burrito.com",
    number: "FRB1235476",
  },
  {
    name: "Lucas Harper",
    company: "Stone Tech Zone",
    email: "lucas@stone-tech.com",
    number: "FRB1235476",
  },
  {
    name: "Ethan James",
    company: "Fiber Notion",
    email: "ethan@fiber.com",
    number: "FRB1235476",
  },
];

export const newestTransactions = [
  {
    name: "Netflix",
    date: "27 March 2022, at 12:30 PM",
    price: "- $2,500",
    logo: FaArrowDown,
  },
  {
    name: "Apple",
    date: "27 March 2022, at 12:30 PM",
    price: "+ $2,500",
    logo: FaArrowUp,
  },
];

export const olderTransactions = [
  {
    name: "Stripe",
    date: "26 March 2022, at 13:45 PM",
    price: "+ $800",
    logo: FaArrowUp,
  },
  {
    name: "HubSpot",
    date: "26 March 2022, at 12:30 PM",
    price: "+ $1,700",
    logo: FaArrowUp,
  },
  {
    name: "Webflow",
    date: "26 March 2022, at 05:00 PM",
    price: "Pending",
    logo: AiOutlineExclamation,
  },
  {
    name: "Microsoft",
    date: "25 March 2022, at 16:30 PM",
    price: "- $987",
    logo: FaArrowDown,
  },
];

export const pageVisits = [
  {
    pageName: "/argon/",
    visitors: "4,569",
    uniqueUsers: 340,
    bounceRate: "46,53%"
  },
  {
    pageName: "/argon/index.html",
    visitors: "3,985",
    uniqueUsers: 319,
    bounceRate: "46,53%"
  },
  {
    pageName: "/argon/charts.html",
    visitors: "3,513",
    uniqueUsers: 294,
    bounceRate: "36,49%"
  },
  {
    pageName: "/argon/tables.html",
    visitors: "2,050",
    uniqueUsers: 147,
    bounceRate: "50,87%"
  },
  {
    pageName: "/argon/profile.html",
    visitors: "1,795",
    uniqueUsers: 190,
    bounceRate: "46,53%"
  },
]

export const socialTraffic = [
  {
    referral: "Facebook",
    visitors: "1,480",
    percentage: 60,
    color: "orange",
  },
  {
    referral: "Facebook",
    visitors: "5,480",
    percentage: 70,
    color: "orange",
  },
  {
    referral: "Google",
    visitors: "4,807",
    percentage: 80,
    color: "cyan",
  },
  {
    referral: "Instagram",
    visitors: "3,678",
    percentage: 75,
    color: "cyan",
  },
  {
    referral: "Twitter",
    visitors: "2,645",
    percentage: 30,
    color: "orange",
  }
]
